export default __webpack_public_path__ + "static/media/landing_bg.2d79a284.png";